import { render } from "./WelfareBenefits.vue?vue&type=template&id=092820ea"
import script from "./WelfareBenefits.vue?vue&type=script&lang=js"
export * from "./WelfareBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__